
/**
 * JavaScript React Framework
 */
import React from 'react';
// import ReactDom from 'react-dom';

/**
 * React-Bootstrap
 */ 
import { Jumbotron, Button, Grid, Row, Col } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import MarketingBlock from '../../common/content/MarketingBlock.js';

import pdf_01 from "../../../assets/pdf/informatics/BrownTS_2017_BrownsGeneralizedVitalsEquation.pdf";
import pdf_02 from "../../../assets/pdf/informatics/Faculty_Poster_v5.pdf";
import pdf_03 from "../../../assets/pdf/informatics/Cleansed_MAP_VITALS_Equation.pdf";
import pdf_04 from "../../../assets/pdf/informatics/Cleansed_FZ_TSB_ORX_VENTILATION.pdf";
import pdf_05 from "../../../assets/pdf/informatics/Custom_ETL_Software.pdf";
import pdf_06 from "../../../assets/pdf/informatics/REDCap_API_Demo.pdf";
import pdf_07 from "../../../assets/pdf/informatics/REDCap_ETL_Technical_Demo.pdf";


/**
 * Note: Your components tell React what you want to render
 */
class Informatics extends React.Component {
	render() {
		return (
			<div id="Informatics">
				<Jumbotron>
	          <div>
	          	<Grid>
				    		<Row>
				    			<Col xs={12} md={12}>
				    				<center>
					    				<MarketingBlock header="Clinical Bioinformatics and Biostatistics Core">
					    					My most recent position had been affiliated with the prestigious University of Arizona (<a href="http://www.arizona.edu/">UA</a>) Clinical Bioinformatics &amp; Biostatistics Core (<a href="http://cb2.uahs.arizona.edu/">CB2</a>) alongside <a href="http://garcialab.uahs.arizona.edu/">Garcia Lab</a>, Lussier Research Group (<a href="http://lussierlab.net/">Lussier Lab</a>), the UA <a href="http://www.bio5.org/">BIO5</a> Institute initiative, and the UA <a href="http://uacc.arizona.edu/">Cancer Center</a> as a Senior Appointed Professional and member of the <a href="http://uahs.arizona.edu/senior-vice-president-health-sciences">Office of Senior Vice President</a> of Health Sciences.
					    					<hr/>
					    					During my three-year senior academic medicine and informatics tour, my role required experience with several programming languages spanning systems, applications, and databases emphasizing C# and highly complex SQL with experimental work in neural networks (Hopfield). My work primarily involved complex SQL report development for informatics analysis using <a href="http://www.epic.com/software">EPIC Clarity</a> and Microsoft SQL Server Management Studio (SSMS) with some SQL Server Integration Services (SSIS).  While in this role, I developed a generalized systems duress applied mathematics function [<a href={pdf_01}>paper</a>] and championed a paradigm for hospital medical record de-identification as well as prototype technology for de-identification. 
					    				</MarketingBlock>
				    				</center>
				    			</Col>
				    		</Row>
				    	</Grid>
	          </div>

	          <Grid>
							<Row>
								<Col xs={6} md={2}>
									<Button className="stretch" href={pdf_02}>Research</Button>
								</Col>

								<Col xs={6} md={2}>
									<Button className="stretch" href={pdf_05}>ETL Software</Button>
								</Col>

								<Col xs={6} md={2}>
									<Button className="stretch" href={pdf_03}>SQL Example</Button>
								</Col>

								<Col xs={6} md={2}>
									<Button className="stretch" href={pdf_04}>UDF Example</Button>
								</Col>

								<Col xs={6} md={2}>
									<Button className="stretch" href={pdf_06}>REDCap ETL</Button>
								</Col>

								<Col xs={6} md={2}>
									<Button className="stretch" href={pdf_07}>Clarity ETL</Button>
								</Col>
							</Row>
						</Grid>

				</Jumbotron>

				<Grid className="blockpadding">
	    		<div className="well">

		    		<Row>
		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Complex SQL & T-SQL">
		    					The majority of my University work delved into highly complex SQL, Transact-SQL (<a href="https://en.wikipedia.org/wiki/Transact-SQL">T-SQL</a>) within Microsoft SQL-Server Management Studio, and SQL-Server Integration Services (<a href="https://en.wikipedia.org/wiki/SQL_Server_Integration_Services">SSIS</a>) extracting medical data conforming to a prescribed protocol aiding principle investigators in their mission to study medical phenomena and disease alike.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Technology Research">
		    					Toward the end of my academic tour, I had prototyped a multi-threaded desktop data science statistical software platform (project Asclepius) to aid both our team and the University in supporting a phase-II R01 grant initiative: <a href="https://grants.nih.gov/grants/guide/pa-files/PAR-17-045.html">Focused Technology Research and Development</a>. The principle idea was to better understand the relationship between variables. [<a href="/index.html#page=KarnaRam">Karna-Ram</a>]
		    				</MarketingBlock>
		    			</Col>
		    		</Row>

						<Row>
		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="SQL-Dispatching Engine">
		    					In order to optimize the efforts to <a href="https://en.wikipedia.org/wiki/De-identification">de-identify</a> medical records with our hospital EPIC Clarity environment, I developed an engine with dependency tracking to automate the process of producing comprehensive de-identified medical records. The dispatching engine used string-based dependency definitions and rudimentary intelligence to think through the dependencies.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Custom C# Software">
		    					Our group was known for innovation beyond off-the-shelf solutions. While our group primarily focused on complex SQL and data extraction, we often had the opportunity to develop custom desktop windows software in C# as well as <a href="https://www.asp.net/">ASP.NET</a> websites using C# and <a href="https://getbootstrap.com/">Bootstrap</a>. Extending this work, I had experimented with <a href="https://nodejs.org/en/">Node.js</a>, <a href="https://www.mongodb.com/">MondoDB</a>, and <a href="https://angularjs.org/">AngularJS</a>.
		    				</MarketingBlock>
		    			</Col>
		    		</Row>
	    		</div>
	    	</Grid>

    	</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default Informatics;



// WEBPACK FOOTER //
// ./src/cba/appspec/body/Informatics.js